import React, { useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useParams } from 'react-router-dom'
import * as actions from 'data/redux/actions'

import { useGame } from 'data/hooks'

export const useMenu = (slug) => {

  const dispatch = useDispatch()
  const params = useParams()
  const gameId = params.gameId || playmotiv.game?.gameId
  const { player } = useGame(gameId) 
  const [ menu, setMenu ] = useState([])
  const menus = useSelector(state => state.ui.menus)

  useEffect(() => {

    dispatch(actions.uiMenusLoad())

  }, [slug])


  const getRecursiveMenu = (options, parentId) => {

    const levelOptions = options
    .filter(option => option.parent === parentId)
    .filter(option => {

      if (option.type !== '') {

        if(!player && option.type !== 'logout') {

          return false
        }
        
        const keys = option.type.split(" ")

        const visible = keys.reduce((visible, key) => {

          const [type, expr] = key.split(":")

          if (type === 'visible') {

            const [k, v] = expr.split("_")

            return visible || eval(`"${player[k]}" === "${v}"`)
          }

          return true

        }, false)

        return visible
      }

      return true
    })

    if (levelOptions.length > 0) {

      return levelOptions.map((option, index) => {

        return {
            label: option.title,
            key: `${option.id}`,
            data: option,
            children: getRecursiveMenu(options, option.id)
        }
      })

    } else {

        return undefined
    }
  }

  useEffect(() => {
      
    if (!menus) return
    if (!menus[slug]) return

    const menu = getRecursiveMenu(menus[slug].options, 0)
    
    setMenu(menu)

  }, [menus])
  
  return {
    menu
  }
}
